import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { GetWebNotifications, UpdateWebNotificationSeen } from '../../store/notifications.actions';
import { LoaderShow, LoaderHide } from 'src/app/features/loader/store/loader.actions';
import { debounceTime, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Location } from '@angular/common';
import { PAGE_LIMIT } from 'src/app/app.constants';




@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  page = 1;
  notificationWebList: Array<any> = [];
  stopper$: Subject<any> = new Subject();
  totalPages;
  total: any;
  canShowPagination = false;


  currentPage;

  limitPerPageOptions;
  pageSizeDefault = '40';
  pageSize = this.pageSizeDefault;

  @ViewChild('listDiv', { static: false })
  listDiv: ElementRef;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) { }

  ngOnInit() {
    this.limitPerPageOptions = PAGE_LIMIT;


    this.store.dispatch(new GetWebNotifications({ limit: this.pageSize, page: this.page }));
    this.store.select(state => state.notifications.notifWebList).pipe(takeUntil(this.stopper$)).subscribe((docsList: any) => {

      if (Object.keys(docsList).length) {
        this.totalPages = docsList.pages;
        this.total = docsList.total;
        this.pageSize = docsList.limit;
        this.currentPage = docsList.page;
        if (this.listDiv) {
          this.listDiv.nativeElement.scrollTop = 0;
        }
        this.canShowPagination = docsList.pages > 1;
        this.store.dispatch(new LoaderHide());
        // if (docsList.page === 1) {
        this.notificationWebList = docsList.docs;
        // } else {
        // this.notificationWebList.push(...docsList.docs);
        // }
        window.scrollTo(0, 0);
      }

    });
  }

  goto(doc) {
    if (doc.read == false) {
      this.store.dispatch(new UpdateWebNotificationSeen(doc._id));
    }

    switch (doc.notificationType) {
      case 'DOCUMENTS':
        this.router.navigate(['home/resources/doc/' + doc.docId]);
        break;

      case 'TASK':
        this.router.navigate(['home/tasks/' + doc.taskId]);
        break;

      case 'MESSAGES':
        this.router.navigate(['/home/messages/my-messages']);
        break;

      case 'SYSTEM_FOLDER':
        this.router.navigate(['home/resources/me/citis/' +doc.folderId]);
        break;

      case 'CONTRACT':
        if (doc.title.includes('invoice')) {
          this.router.navigate([`/home/contract-management/notifications/${doc.contractId}/invoices`])
        }
        else {
          this.router.navigate([`/home/contract-management/notifications/${doc.contractId}/contract-details`])
        }
        break;

      default:
        this.page = 1;
        this.store.dispatch(new GetWebNotifications({ limit: this.pageSize, page: this.page }));
        break;
    }
  }


  onScroll(event) {
    const tableViewHeight = event.target.offsetHeight; // viewport: ~500px
    const tableScrollHeight = event.target.scrollHeight; // length of all table
    const scrollLocation = event.target.scrollTop; // how far user scrolled
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 0;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation >= limit) {
      this.getNotifications();
    }
  }


  getNotifications() {
    this.page++;
    let apiData = {
      limit: this.pageSize,
      page: this.page,
    };
    if (this.page <= this.totalPages) {
      this.store.dispatch(new GetWebNotifications(apiData));
    }
  }

  getNextPageData(event) {
    const data = {
      limit: this.pageSize,
      page: event
    };
    this.store.dispatch(new LoaderShow());
    this.store.dispatch(new GetWebNotifications(data));
  }


  onChange(event) {
    const data = {
      limit: event.value,
      page: 1
    };
    this.store.dispatch(new LoaderShow());
    this.store.dispatch(new GetWebNotifications(data));
  }

}
